import { CustomCard } from "./CustomCard";
import { generateClient } from "aws-amplify/api";
import { listPosts } from "../graphql/queries";
import { useEffect, useState } from "react";
import { GraphQLResult } from "@aws-amplify/api";

const client = generateClient()

const AnnouncementPanel = () => {

    const [posts, setPosts] = useState<any[]>([])

    useEffect(() => {

        const fetchPosts = async () => {
            const allPosts = await client.graphql({
                query: listPosts,
                variables: { filter: { tags: { contains: 'announcement' } } }
            });
            console.log(allPosts);

            setPosts((allPosts as GraphQLResult<any>).data.listPosts.items); // Save the posts to state
        }

        fetchPosts();
        setPosts(posts);
    }, [])

    return (
        <>
            <CustomCard posts={posts} />
        </>
    );
}

export default AnnouncementPanel;